function naviAnimation() {
  $(".l-jokatsu-navi a").on("click", function (e) {
    e.preventDefault();
    var winW = $(window).width();
    var href = $(this).attr("href");
    var target = $(href).offset().top;
    if (winW <= 750) {
      target = target - 70;
    } else {
      target = target - 130;
    }
    $("html,body").animate({ scrollTop: target }, 150);
  });
}

function naviScroll() {
  var naviHeight = $(".l-jokatsu-navi").outerHeight();
  var offTop = $(".l-jokatsu-column__right").offset().top;
  var offBottom =
    $("#p-jokatsu").offset().top + $("#p-jokatsu .l-body__inner").outerHeight();
  var scrTop = $(window).scrollTop();
  if (scrTop > offTop - 130) {
    if (scrTop + 130 + naviHeight + 30 > offBottom) {
      $(".l-jokatsu-navi").removeClass("fixed").addClass("absolute");
    } else {
      $(".l-jokatsu-navi").removeClass("absolute").addClass("fixed");
    }
  } else {
    $(".l-jokatsu-navi").removeClass("fixed").removeClass("absolute");
  }
}

function toggleSystemHover() {
  var hoverBoxPosition = -1;
  var smpPosition = -1;
  function hoverAnimation(hoverBox, pastPosition, index) {
    $(".l-sec03-system__list li").removeClass("active");
    $('.l-sec03-system__list li[data-index="' + index + '"]').addClass(
      "active"
    );
    var winW = $(window).width();
    if (winW > 750) {
      if (hoverBoxPosition == pastPosition) {
        hoverBox
          .find(".l-sec03-system__list__hover__content")
          .eq(index)
          .addClass("current")
          .siblings(".l-sec03-system__list__hover__content")
          .removeClass("current");
        TweenMax.to(
          hoverBox.find(".l-sec03-system__list__hover__content").eq(index),
          0.3,
          {
            opacity: 1,
            ease: Power2.easeOut,
          }
        );
        TweenMax.to(
          hoverBox
            .find(".l-sec03-system__list__hover__content")
            .eq(index)
            .siblings(".l-sec03-system__list__hover__content"),
          0.15,
          {
            opacity: 0,
            ease: Power2.easeOut,
          }
        );
      } else if (pastPosition == -1) {
        hoverBox
          .find(".l-sec03-system__list__hover__content")
          .eq(index)
          .addClass("current")
          .siblings(".l-sec03-system__list__hover__content")
          .removeClass("current");
        TweenMax.to(
          hoverBox.find(".l-sec03-system__list__hover__content").eq(index),
          0.3,
          {
            opacity: 1,
            ease: Power2.easeOut,
          }
        );
        TweenMax.to(
          hoverBox
            .find(".l-sec03-system__list__hover__content")
            .eq(index)
            .siblings(".l-sec03-system__list__hover__content"),
          0.15,
          {
            opacity: 0,
            ease: Power2.easeOut,
          }
        );

        var target = $(".l-sec03-system__list > ul").eq(hoverBoxPosition);
        TweenMax.to(target, 0.3, {
          marginBottom: 170,
          ease: Power2.easeOut,
        });
        TweenMax.set(hoverBox, {
          height: 0,
          top: 192 * (hoverBoxPosition + 1),
        });
        TweenMax.to(hoverBox, 0.3, {
          height: 170,
          ease: Power2.easeOut,
        });
      } else {
        hoverBox
          .find(".l-sec03-system__list__hover__content")
          .eq(index)
          .addClass("current")
          .siblings(".l-sec03-system__list__hover__content")
          .removeClass("current");
        TweenMax.to(
          hoverBox.find(".l-sec03-system__list__hover__content").eq(index),
          0.3,
          {
            opacity: 1,
            ease: Power2.easeOut,
          }
        );
        TweenMax.to(
          hoverBox
            .find(".l-sec03-system__list__hover__content")
            .eq(index)
            .siblings(".l-sec03-system__list__hover__content"),
          0.15,
          {
            opacity: 0,
            ease: Power2.easeOut,
          }
        );
        TweenMax.to($(".l-sec03-system__list__hover__navi"), 0.3, {
          opacity: 0,
          ease: Power2.easeOut,
        });
        TweenMax.to(hoverBox, 0.3, {
          height: 0,
          ease: Power2.easeOut,
        });
        TweenMax.to($(".l-sec03-system__list ul"), 0.3, {
          marginBottom: 0,
          ease: Power2.easeOut,
          onComplete: function onComplete() {
            var target = $(".l-sec03-system__list > ul").eq(hoverBoxPosition);
            TweenMax.to($(".l-sec03-system__list__hover__navi"), 0.3, {
              opacity: 1,
              ease: Power2.easeOut,
            });
            TweenMax.to(target, 0.3, {
              marginBottom: 170,
              ease: Power2.easeOut,
            });
            TweenMax.set(hoverBox, {
              height: 0,
              top: 192 * (hoverBoxPosition + 1),
            });
            TweenMax.to(hoverBox, 0.3, {
              height: 170,
              ease: Power2.easeOut,
            });
          },
        });
      }
    } else {
      var pPosition = smpPosition;
      smpPosition = Math.floor(index / 2);

      hoverBox
        .find(".l-sec03-system__list__hover__content")
        .eq(index)
        .addClass("current")
        .siblings(".l-sec03-system__list__hover__content")
        .removeClass("current");
      TweenMax.to(
        hoverBox
          .find(".l-sec03-system__list__hover__content")
          .eq(index)
          .siblings(".l-sec03-system__list__hover__content"),
        0.15,
        {
          opacity: 0,
          ease: Power2.easeOut,
        }
      );

      let _delay = 0.3;
      if (smpPosition == pPosition) {
        _delay = 0;
      } else if (pPosition == -1) {
        TweenMax.set(hoverBox, {
          delay: _delay,
          height: 0,
          top: 166 * (smpPosition + 1),
        });
      } else {
        TweenMax.to(hoverBox, 0.3, {
          height: 0,
          ease: Power2.easeOut,
        });
        TweenMax.to($(".l-sec03-system__list ul li"), 0.3, {
          marginBottom: 0,
          ease: Power2.easeOut,
        });
        TweenMax.set(hoverBox, {
          delay: _delay,
          height: 0,
          top: 166 * (smpPosition + 1),
        });
      }
      var target = $(".l-sec03-system__list > ul > li").eq(2 * smpPosition);
      var target2 = $(".l-sec03-system__list > ul > li").eq(
        2 * smpPosition + 1
      );
      $.merge(target, target2);
      TweenMax.to(target, 0.3, {
        delay: _delay,
        marginBottom: hoverBox
          .find(".l-sec03-system__list__hover__content")
          .eq(index)
          .find(".l-sec03-system__list__hover__content__inner")
          .outerHeight(),
        ease: Power2.easeOut,
      });
      TweenMax.to(hoverBox, 0.3, {
        delay: _delay,
        height: hoverBox
          .find(".l-sec03-system__list__hover__content")
          .eq(index)
          .find(".l-sec03-system__list__hover__content__inner")
          .outerHeight(),
        ease: Power2.easeOut,
        onComplete: function () {
          TweenMax.to(
            hoverBox.find(".l-sec03-system__list__hover__content").eq(index),
            0.3,
            {
              opacity: 1,
              ease: Power2.easeOut,
            }
          );
        },
      });
    }
  }
  $(".l-sec03-system__list li").on("click", function () {
    var pastPosition = hoverBoxPosition;
    var index = $(this).data("index");
    var hoverBox = $(".l-sec03-system__list__hover");

    if (index < 4) {
      hoverBoxPosition = 0;
    } else if (index < 8) {
      hoverBoxPosition = 1;
    } else if (index < 12) {
      hoverBoxPosition = 2;
    } else {
      hoverBoxPosition = 3;
    }

    hoverAnimation(hoverBox, pastPosition, index);
  });
  $(".l-sec03-system__list__hover__navi .prev").on("click", function () {
    var pastPosition = hoverBoxPosition;
    var index =
      $(".l-sec03-system__list__hover__content.current").data("index") - 1;
    if (index < 0) {
      index = 11;
    }
    var hoverBox = $(".l-sec03-system__list__hover");
    if (index < 4) {
      hoverBoxPosition = 0;
    } else if (index < 8) {
      hoverBoxPosition = 1;
    } else if (index < 12) {
      hoverBoxPosition = 2;
    } else {
      hoverBoxPosition = 3;
    }

    hoverAnimation(hoverBox, pastPosition, index);
  });
  $(".l-sec03-system__list__hover__navi .next").on("click", function () {
    var pastPosition = hoverBoxPosition;
    var index =
      $(".l-sec03-system__list__hover__content.current").data("index") + 1;
    if (index > 11) {
      index = 0;
    }
    var hoverBox = $(".l-sec03-system__list__hover");
    if (index < 4) {
      hoverBoxPosition = 0;
    } else if (index < 8) {
      hoverBoxPosition = 1;
    } else if (index < 12) {
      hoverBoxPosition = 2;
    } else {
      hoverBoxPosition = 3;
    }

    hoverAnimation(hoverBox, pastPosition, index);
  });

  var windowWidth = null;
  $(window).on("load resize", function () {
    var pastWidth = windowWidth;
    windowWidth = $(window).width();
    if (windowWidth != null) {
      if (
        (windowWidth > 750 && pastWidth <= 750) ||
        (windowWidth <= 750 && pastWidth > 750)
      ) {
        hoverBoxPosition = -1;
        smpPosition = -1;
        $(".l-sec03-system__list__hover").css("top", "110%");
        TweenMax.set($(".l-sec03-system__list ul"), {
          marginBottom: 0,
        });
        TweenMax.set($(".l-sec03-system__list ul li"), {
          marginBottom: 0,
        });
      }
    }
  });
}

function togglePickup() {
  $(".l-jokatsu-pickup__title").on("click", function () {
    var winW = $(window).width();
    if (winW <= 750) {
      if ($(this).hasClass("active")) {
        $(this).siblings(".l-jokatsu-pickup__content").slideUp(400);
        $(this).removeClass("active");
      } else {
        // $('.l-jokatsu-pickup__title').removeClass('active');
        // $('.l-jokatsu-pickup__content').stop().slideUp(400);
        $(this).siblings(".l-jokatsu-pickup__content").stop().slideDown(400);
        $(this).addClass("active");
      }
    }
  });
}

function initPickup() {
  var winW = $(window).width();
  if (winW > 750) {
    $(".l-jokatsu-pickup__content").attr("style", "");
  }
}

var modal = {
  $trigger: $(".js__modal-trigger"),
  $content: $(".c-modal2"),
  $inner: $(".c-modal2__inner"),
  $close: $(".js__modal-close"),
  $overlay: $(".c-modal2__overlay"),
  target: 0,
  height: 0,
  position: 0,
  scrTop: 0,
  type: "",
  MOUSEWHEEL:
    "onwheel" in document
      ? "wheel"
      : "onmousewheel" in document
      ? "mousewheel"
      : "DOMMouseScroll",
  init: function init() {
    setTimeout(function () {
      TweenMax.set(modal.$content, { display: "none" });
      TweenMax.set(modal.$overlay, { display: "block" });
    }, 200);

    modal.$trigger.on("click", function () {
      modal.open();
      return false;
    });
    modal.$close.on("click", function () {
      modal.close();
    });
  },
  open: function open() {
    TweenMax.set(modal.$inner, {
      y: "50px",
    });
    TweenMax.to(modal.$content, 0.18, {
      display: "block",
      opacity: 1,
      ease: Power2.easeOut,
      onComplete: function onComplete() {
        modal.scroll();
        modal.height = $(modal.target).find(".c-modal__inner").outerHeight();
        modal.resize();
        TweenMax.set($(".c-modal__target"), { opacity: 1 });
        TweenMax.to(modal.$inner, 0.38, {
          opacity: 1,
          y: "0px",
          ease: Power2.easeOut,
        });
      },
    });
  },
  close: function close() {
    $(window).scrollTop(modal.scrTop);
    TweenMax.to(modal.$inner, 0.48, {
      opacity: 0,
      y: "50px",
      ease: Power2.easeOut,
      onComplete: function onComplete() {
        TweenMax.to(modal.$content, 0.18, {
          display: "none",
          opacity: 0,
          ease: Power2.easeOut,
        });
        TweenMax.set($(".c-modal__target"), { opacity: 0 });
        //$(document).off(modal.MOUSEWHEEL);
      },
    });
  },
  resize: function resize() {
    let _h = $(window).height();
    let _w = $(window).width();
    modal.scrTop = $(document).scrollTop();
    if (_w <= 750) {
      $(".c-modal2__target").height(_h - 80);
      modal.position = modal.scrTop + 70;
    } else {
      $(".c-modal2__target").height(_h - 180);
      modal.position = modal.scrTop + 110;
    }
    TweenMax.set(modal.$inner, { top: modal.position });
  },
  scroll: function () {
    //特定要素だけスクロール可能
    var $target = document.getElementById("js__modal_scroll");
    var $no_scroll = document.getElementById("js__no_scroll");
    $target.scrollTop = 1;

    $target.addEventListener("scroll", function (event) {
      if ($target.scrollTop === 0) {
        $target.scrollTop = 1;
      } else if (
        $target.scrollTop + $target.clientHeight ===
        $target.scrollHeight
      ) {
        $target.scrollTop = $target.scrollTop - 1;
      }
    });

    $($no_scroll).on(modal.MOUSEWHEEL, function (e) {
      e.preventDefault();
    });
    $no_scroll.addEventListener("touchmove", function (e) {
      e.preventDefault();
    });
  },
};

$(document).ready(function () {
  if ($("#p-jokatsu")[0]) {
    naviAnimation();
    naviScroll();
    togglePickup();
    toggleSystemHover();
  }
});

$(window).on("scroll", function () {
  if ($("#p-jokatsu")[0]) {
    naviScroll();
  }
});

$(window).on("load", function () {
  if ($("#p-jokatsu")[0]) {
    if ($(".c-modal2")[0]) modal.init();
    TweenMax.set($(".c-modal__target iframe"), { display: "none" });
    modal.resize();

    let _hash = location.hash;
    if (_hash == "#history") {
      var _posi =
        $(".l-sec02-project__action").offset().top -
        $("#l-header__fixed").height();
      console.log(_posi);
      $(window).scrollTop(_posi);
      setTimeout(function () {
        $(window).scrollTop(_posi);
        modal.open();
      }, 6e2);
    }
  }
});

$(window).on("resize", function () {
  if ($("#p-jokatsu")[0]) {
    initPickup();
    modal.resize();
  }
});
